export default __webpack_public_path__ + "61be95dbae5cac92972e9b7899b7b265.png";